import styled from "@emotion/styled";
import { Box, Paper } from "@mui/material";

export const PaperContainer = styled(Paper)`
    padding: 1rem;
    width: 450px;
    min-height: 20%;
    max-height: 85%;
    overflow-y: auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: column;
`

export const ButtonsContainer = styled(Box)`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
`

